import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import BackButton from '../back-button/BackButton'

class AboutScreen extends Component {

  render() {
    return (
      <div>
        <h1 className="blue">О проекте «Открытка из Кузбасса»</h1>
        <p style={{marginBottom: '30px'}}>Авторы кузбасских открыток - <a style={{color: '#0279de'}} target="_blank" href="http://atwinta.ru/portfolio">Digital-агентство &laquo;Атвинта&raquo;</a></p> 
        <p style={{marginBottom: '30px'}}>Наше мастерство подтверждается тем, что мы входим в ТОП-100 ведущих digital-продакшнов России 2017 по версии Tagline. А недавно мы сделали <a style={{color: '#0279de'}} target="_blank" href="https://www.behance.net/gallery/59064837/SDS-Intranet">лучший в России корпоративный портал.</a></p>
        <p style={{marginBottom: '30px'}}>Нашим специалистам под силу проект любой сложности. В каждый мы вкладываем душу, профессионализм и щепотку магии. А вы — получаете великолепный продукт, которым можно гордиться и удивлять.</p>
        <p style={{marginBottom: '90px'}}>Если вам недостаточно открытки, <a style={{color: '#0279de'}} target="_blank" href="http://atwinta.ru">закажите у нас сайт.</a> Такой же суровый и красивый, как кузбасская зима.</p>
        <BackButton title="Назад"/>
      </div>
    );
  }
}

export default connect()(AboutScreen)


// WEBPACK FOOTER //
// ./src/components/postcard/AboutScreen.js